import React, { Suspense, lazy } from 'react';
import Hero from '../Components/Hero';
import SEOMeta from '../Components/common/SEOMeta';

const About = lazy(() => import('../Components/About'));
const Experience = lazy(() => import('../Components/Experience'));
const Service = lazy(() => import('../Components/Service'));
const Project = lazy(() => import('../Components/Project'));
const Contact = lazy(() => import('../Components/Contact'));

const LoadingFallback = () => (
  <div
    role="status"
    aria-live="polite"
    aria-busy="true"
    style={{
      display: 'flex',
      justifyContent: 'center',
      padding: '50px',
      color: 'var(--primary-color, #00f0ff)'
    }}
  >
    <span className="sr-only">Loading content...</span>
    <span aria-hidden="true">Loading Section...</span>
  </div>
);

const HomePage = () => {
    return (
        <>
            <SEOMeta 
                title="Full Stack Developer in Chennai | Mowli S"
                description="Full stack & MERN developer based in Chennai, building fast, production-ready websites and web apps for clients across Tamil Nadu. View recent work."
                url="https://mowli.in/"
            />
            <Hero />
            <Suspense fallback={<LoadingFallback />}>
                <About />
                <Experience />
                <Service />
                <Project />
                <Contact />
            </Suspense>
        </>
    );
};

export default HomePage;
